const styles = (theme) => ({
  container: { display: "flex", flexDirection: "column", gap: 1 },
  statusPaper: {
    display: "flex",
    width: "100%",
    height: "100%",
    borderRadius: 4,
    flexDirection: "column",
    p: 2,
    position: "relative",
    overflow: "hidden",
  },
  linearProgress: {
    position: "absolute",
    top: 0,
    width: "100%",
    left: 0,
  },
  boxStatus: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  statusTitle: {
    fontWeight: 500,
    fontSize: "20px",

    mb: 0.4,
    "@media (max-width: 600px)": {
      fontSize: "16px",
      mb: 0.1,
    },
  },
  statusContent: {
    display: "flex",
    height: "100%",
    width: "100%",
  },
  customTooltip: {
    width: "14px",
    height: "14px",
    borderRadius: "2px",
    border: `1px solid ${theme.palette.cardGraphic.graphColor["green"]}`,
  },
  boxTooltip: {
    bgcolor: theme.palette.paletteCharts.lineCharts,
    padding: "8px",
    borderRadius: "8px",
  },
  lineChartPaper: {
    display: "flex",
    p: 2,
    borderRadius: 4,
    flexDirection: "column",
    gap: 1,
    position: "relative",
    overflow: "hidden",
  },
  linearProgress: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 1,
  },
  lineChartHeader: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: 1,
  },
  lineChartIconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    p: 0.4,
    borderRadius: 1,
  },
  lineChartIcon: { fontSize: "22px", color: theme.palette.white.main },
  lineChartTitle: {
    fontWeight: 500,
    fontSize: "20px",
    mb: 0.4,
    "@media (max-width: 600px)": {
      fontSize: "16px",
      mb: 0.1,
    },
  },
  lineChartChip: {
    width: "100px",

    border: "0.6px solid ",
    borderRadius: "10px",
    height: "24px",
    fontWeight: 500,
  },
});

export default styles;
